@@ -0,0 +1,208 @@
<template>
  <div>
    <div style="display: flex;">
      <v-btn
        color="#FE0012"
        :loading="loadingNinja || ninjaVanOrder.loading"
        depressed
        dark
        @click.stop="dialogTypeShipping = true"
        style="display: inline-block; margin-right: -5px; border-radius: 20px 20px 20px 0px !important;"
      >
        <v-icon class="mr-1">local_shipping</v-icon>{{ $t('send_by_ninja') }}
      </v-btn>
    </div>
    <v-dialog style="z-index: 210" v-model="dialogTypeShipping" persistent width="500">
      <v-card>
        <v-card-title class="mb-0 pb-0">
          <v-layout wrap>
            <v-flex xs6
              ><h2>{{ $t('choose_mode_of_transportation') }}</h2>
            </v-flex>
            <v-flex xs6 class="text-xs-right">
              <v-btn flat fab small @click="dialogTypeShipping = false">
                <v-icon>close</v-icon>
              </v-btn>
            </v-flex>
          </v-layout></v-card-title
        >
        <v-card-text>
          <v-layout wrap>
            <v-flex xs6 class="text-xs-center">
              <v-hover>
                <v-card
                  slot-scope="{ hover }"
                  :class="`elevation-${hover ? 12 : 2}`"
                  @click="shipWithNinja('pick_up')"
                  :color="hover ? 'primary' : ''"
                  :dark="hover ? true : false"
                  class="pa-2 ma-2"
                  style="cursor: pointer;"
                >
                  <v-card-text>
                    <span style="font-size: 16px; font-weight: bold;">
                      <v-icon
                        style="font-size: 33px; vertical-align: middle; color: black"
                        class="mr-1"
                        >local_shipping</v-icon
                      >

                      Pick up</span
                    >
                  </v-card-text>
                </v-card>
              </v-hover>
            </v-flex>
            <v-flex xs6 class="text-xs-center">
              <v-hover>
                <v-card
                  slot-scope="{ hover }"
                  :class="`elevation-${hover ? 12 : 2}`"
                  @click="shipWithNinja('drop_off')"
                  :color="hover ? 'primary' : ''"
                  :dark="hover ? true : false"
                  class="pa-2 ma-2"
                  style="cursor: pointer;"
                >
                  <v-card-text>
                    <span style="font-size: 16px; font-weight: bold;">
                      <v-icon
                        style="font-size: 33px; vertical-align: middle; color: black"
                        class="mr-1"
                        >inventory</v-icon
                      >
                      Drop off</span
                    >
                  </v-card-text>
                </v-card>
              </v-hover>
            </v-flex>
          </v-layout>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog style="z-index: 210" v-model="loadingNinja" persistent width="300">
      <v-card color="primary" dark>
        <v-card-text>
          กรุณารอสักครู่
          <v-progress-linear
            color="#FFFFFF"
            style="border-radius: 5px;"
            class="text-xs-center"
            v-model="ninjaVanLoad"
            height="19"
          >
            <strong style="font-size: 14px; color: #FFF;">{{ ninjaVanLoad }}%</strong>
          </v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  props: ['value', 'cbAll'],
  data: function() {
    return {
      dialogTypeShipping: false,
      summary: this.value,
      ninjaVanOrder: {
        status: '',
        loading: false,
        interval: null,
        show: false
      },
      ninjaVanLoad: 0,
      loadingNinja: false
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot',
      getPageProfile: 'getPageProfile',
      currentLang: 'currentLang'
    })
  },
  methods: {
    async shipWithNinja(type) {
      const vm = this
      vm.dialogTypeShipping = false
      let selected = vm.summary.filter(el => {
        return vm.cbAll.includes(el.id) && ['paid'].includes(el.status)
      })
      let notPass = []
      selected.map(item => {
        let address = item.nameaddress ? item.nameaddress.split(' , ') : null
        if (address.includes('')) {
          notPass.push(item.id)
        }
      })
      if (notPass.length > 0) {
        vm.$swal({
          title: `ไม่สามารถจัดส่งออเดอร์ดังต่อไปนี้ได้ ${notPass}`,
          type: 'warning',
          confirmButtonText: vm.$t('Confirm')
        })
      } else {
        selected = selected.map(item => item.id)
        if (selected.length == 0) {
          await vm.$swal({
            title: vm.$t('send_with_ninja_paid_only'),
            type: 'warning',
            confirmButtonText: vm.$t('Confirm')
          })
        } else {
          vm.createOrderNinja(selected, type)
        }
      }
    },
    async createOrderNinja(selected, type) {
      const vm = this
      try {
        vm.ninjaVanLoad = 0
        vm.loadingNinja = true
        let response = await vm.post(`ninja-van/${vm.selectedBot.pageid}/place-order`, {
          order_ids: selected,
          type: type
        })
        if (response.success) {
          await vm.checkNinjaCreateOrder(selected)
          vm.ninjaVanOrder.show = true
          vm.ninjaVanOrder.status = 'PENDING'
          vm.ninjaVanOrder.interval = setInterval(async () => {
            let responseCreateOrder = await vm.checkNinjaCreateOrder(selected)
            if (
              responseCreateOrder.total_order != 0
            ) {
              if (vm.ninjaVanOrder.status == 'SUCCESS') {
                vm.loadingNinja = false
                vm.dialogTypeShipping = false
                if (vm.ninjaVanOrder.interval) clearInterval(vm.ninjaVanOrder.interval)
                await vm.$swal.fire({
                  title: vm.$t('Success'),
                  type: 'success',
                  confirmButtonText: vm.$t('Confirm'),
                  showCancelButton: false,
                  reverseButtons: true
                })
                vm.$emit('onRefresh')
              } else if (vm.ninjaVanOrder.status == 'FAILED') {
                let dataFailed = ''
                responseCreateOrder.order_data_failed.map(item => {
                  if (item.status === 'FAILED') {
                    try {
                      dataFailed += `${item.orderid} เนื่องจาก: ${
                        JSON.parse(item.response_data_json).error.details[0].message
                      } <br/>`
                    } catch (error) {
                      console.log(error)
                    }
                  }
                })

                vm.loadingNinja = false
                if (vm.ninjaVanOrder.interval) clearInterval(vm.ninjaVanOrder.interval)

                await vm.$swal.fire({
                  title: vm.$t('Error'),
                  html: `ไม่สามารถจัดส่งออเดอร์ดังต่อไปนี้ได้ ${dataFailed}`,
                  type: 'error',
                  confirmButtonText: vm.$t('Confirm'),
                  showCancelButton: false,
                  reverseButtons: true
                })
              }
            } else {
              vm.loadingNinja = false
              if (vm.ninjaVanOrder.interval) clearInterval(vm.ninjaVanOrder.interval)
              await vm.$swal.fire({
                title: vm.$t('Error'),
                html: `ไม่สามารถจัดส่งออเดอร์ดังต่อไปนี้ได้เนื่องจากกรอกข้อมูลไม่ครบ`,
                type: 'error',
                confirmButtonText: vm.$t('Confirm'),
                showCancelButton: false,
                reverseButtons: true
              })
            }
          }, 5000)
        }
        // else if(result.total_failed=0&&result.total_order=0&&result.total_pending){

        // }
      } catch (error) {
        if (error.response && error.response.data.message == 'INVALID_SHOP_ADDRESS') {
          const result = await vm.$swal.fire({
            title: vm.$t('กรุณาตั้งค่าที่อยู่ผู้ส่ง ก่อนทำการส่งกับ Ninja Van'),
            type: 'error',
            confirmButtonText: vm.$t('Confirm'),
            showCancelButton: false,
            reverseButtons: true
          })
          if (result.value) {
            vm.$router.push('/' + vm.currentLang + `/template?tab=ShippingMethod`).catch(() => {})
          }
        } else if (error.response && error.response.data.message == 'IMPORT_LIMIT_EXCEEDED') {
          await vm.$swal.fire({
            title: vm.$t('ไม่สามารถดึงข้อมูลได้ กรุณาลองใหม่อีกครั้งหลังจาก 10 นาที'),
            type: 'error',
            confirmButtonText: vm.$t('Confirm'),
            showCancelButton: false,
            reverseButtons: true
          })
        } else {
          await vm.$swal.fire({
            title: vm.$t('Something went wrong. Please try it again later'),
            type: 'error',
            confirmButtonText: vm.$t('Confirm'),
            showCancelButton: false,
            reverseButtons: true
          })
        }
        vm.loadingNinja = false
      }
    },
    async checkNinjaCreateOrder(selected) {
      const vm = this
      try {
        vm.ninjaVanLoad = 0
        let response = await vm.post(`ninja-van/${vm.selectedBot.pageid}/verify-place-order`, {
          order_ids: selected
        })
        if (response.success) {
          let data = response.result
          if (data.total_order != 0) {
            vm.ninjaVanLoad = parseInt(
              ((data.total_success + data.total_failed) / data.total_order) * 100
            )
            let isPending = data.order_data_pending.some(i => i.status.includes('PENDING'))
            if (isPending) {
              vm.ninjaVanOrder.status = 'PENDING'
            } else {
              let isFailed = data.order_data_failed.some(i => i.status.includes('FAILED'))
              if (isFailed) {
                vm.ninjaVanOrder.status = 'FAILED'
              } else {
                vm.ninjaVanOrder.status = 'SUCCESS'
              }
            }
          }
          else{
            vm.ninjaVanLoad = 0
          }
        }
        return response.result
      } catch (error) {
        throw error
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/ecommerce/ShippingNinja.vue